import { render } from "./HeaderDesktop.vue?vue&type=template&id=67fcc0d2"
import script from "./HeaderDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__